//#region src/third_party_order_provider.ts
var ThirdPartyOrderProvider = /* @__PURE__ */ function(ThirdPartyOrderProvider) {
	ThirdPartyOrderProvider["PaytronixOnlineOrderingWebhook"] = "paytronix-online-ordering-webhook";
	ThirdPartyOrderProvider["VerifoneCommanderPosOrder"] = "verifone-commander-pos-order";
	return ThirdPartyOrderProvider;
}(ThirdPartyOrderProvider || {});
//#endregion
export { ThirdPartyOrderProvider };

//# sourceMappingURL=third_party_order_provider.js.map